if (!customElements.get("f-cart-goal")) {
  class FCartGoal extends HTMLElement {
    connectedCallback() {
      this.requestId = 0;
      this.updateGoal();
      this.unsubscribe = window.FoxThemeEvents.subscribe(
        PUB_SUB_EVENTS.cartUpdate,
        (state) => this.refreshGoal(state)
      );
    }

    disconnectedCallback() {
      if (typeof this.unsubscribe === "function") this.unsubscribe();
      this.controller?.abort();
    }

    updateGoal() {
      const count = Number(this.dataset.promoCount) || 0;
      const progress = Math.min((count / 3) * 100, 100);
      this.goalDone = count >= 3;
      this.classList.toggle("hidden", Number(this.dataset.cartItemCount) === 0);
      this.classList.toggle("f-cartgoal--done", this.goalDone);
      this.style.setProperty("--progress", progress + "%");
      this.querySelector("[data-promo-message]").textContent = this.dataset.promoMessage;
      const bar = this.querySelector('[role="progressbar"]');
      bar.setAttribute("aria-valuenow", String(Math.min(count, 3)));
      bar.setAttribute("aria-valuetext", this.dataset.promoMessage);
      this.querySelector("[data-progress]").dataset.progress = String(progress);
    }

    async refreshGoal(state = {}) {
      const requestId = ++this.requestId;
      this.controller?.abort();
      try {
        let html = state.sections?.["cart-drawer"];
        if (!html) {
          this.controller = new AbortController();
          const response = await fetch(
            FoxThemeSettings.routes.root + "?section_id=cart-drawer",
            { signal: this.controller.signal }
          );
          if (!response.ok) return;
          html = await response.text();
        }
        if (!this.isConnected || requestId !== this.requestId) return;
        const next = new DOMParser()
          .parseFromString(html, "text/html")
          .querySelector("f-cart-goal[data-promotion-goal]");
        if (!next) return;
        const wasDone = this.goalDone;
        this.dataset.promoCount = next.dataset.promoCount;
        this.dataset.promoMessage = next.dataset.promoMessage;
        this.dataset.cartItemCount = next.dataset.cartItemCount;
        this.updateGoal();
        if (!wasDone && this.goalDone && this.dataset.enableConfetti === "true") {
          const target = this.closest(".f-cart-drawer__inner") || this.closest(".cart-template");
          if (target && window.FoxTheme?.Confetti) new window.FoxTheme.Confetti(target);
        }
      } catch (error) {
        if (error.name !== "AbortError") console.error("Unable to refresh cart promotion", error);
      }
    }
  }
  customElements.define("f-cart-goal", FCartGoal);
}
